namespace TabAurous.OMS {
    export interface ToDoMasterForm {
        UserId: Serenity.LookupEditor;
        TaskTypeId: Serenity.LookupEditor;
        Description: Serenity.StringEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        Completed: Serenity.BooleanEditor;
    }

    export class ToDoMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ToDoMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ToDoMasterForm.init)  {
                ToDoMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ToDoMasterForm, [
                    'UserId', w0,
                    'TaskTypeId', w0,
                    'Description', w1,
                    'StartDate', w2,
                    'EndDate', w2,
                    'Completed', w3
                ]);
            }
        }
    }
}
